import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface ChangeBranchProps {
    branchId: number;
    showModal: boolean;
    hide(): void;
    update(branchId: number): void;
    save(): void;
}

interface ChangeBranchModal {
    errors: any;
    loading: boolean;
}

export default class AllocateChangeBranchModal extends React.Component<ChangeBranchProps, ChangeBranchModal> {
    constructor(props: ChangeBranchProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        //update errors
        let change: any = {};
        change["errors"] = errors;
        this.setState(change);

        this.props.update(e.target.value * 1);
    }

    hideModal = () => {
        this.setState({ errors: {} });
        this.props.hide();
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (this.props.branchId <= 0) {
            formIsValid = false;
            errors["branchId"] = "Branch is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();
        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        return (
            <div className="static-modal">
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Change Branch</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="input-group" htmlFor="branchId">
                            <span className="label">Branch</span>
                            <select className="select" id="branchId" name="branchId" value={this.props.branchId} onChange={(e) => this.handleChange(e)}>
                                <option defaultValue="-1" value={-1}></option>
                                <option key={1} value={1}>Bayswater</option>
                                <option key={3} value={3}>Traralgon</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["branchId"]}</span>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }



}